import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f62a8258"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "w100 ion-text-center headline-5" }, "Check-In Successful.", -1))
const _hoisted_2 = { style: {"height":"250px","width":"250px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Thank you. Based on your responses, articles about ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" may be helpful. Close this dialog to see your updated dashboard.")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("CLOSE ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_wellness_circle = _resolveComponent("wellness-circle")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, {
    class: "full-height flex",
    style: {"height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center pt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.latestCheckIn)
                  ? (_openBlock(), _createBlock(_component_wellness_circle, {
                      key: 0,
                      scale: "0.9",
                      size: 250,
                      one: _ctx.latestCheckIn.spiritual,
                      two: _ctx.latestCheckIn.social,
                      three: _ctx.latestCheckIn.psychological,
                      four: _ctx.latestCheckIn.biological
                    }, null, 8, ["one", "two", "three", "four"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "8",
            class: "ion-text-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _hoisted_3,
                _createElementVNode("strong", null, _toDisplayString(_ctx.lowestTopic ? _ctx.lowestTopic.topic : ''), 1),
                _hoisted_4
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center mx-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "8",
            class: "mx-4 ion-text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                class: "auto no-corners",
                expand: "block",
                color: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                style: {"max-width":"400px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}